module.exports = __webpack_public_path__ + "static/img/xiazai.d0403b7d.png";